import { useSelector } from 'react-redux'

import { calculateSectionScore } from '~/pages/anatomyV2/libs/calculateSectionScore'
import SectionCompleteTemplate from '~/pages/anatomyV2/libs/components/SectionCompleteTemplate'
import { SECTION_2_SCORING } from '~/pages/anatomyV2/libs/scoredSections'
import { selectAnswers } from '~/shared/store/common/selects'
import { TPageProps } from '~/shared/types/commonTypes'

const NEXT_SECTION_NUMBER = 3
const POINTS_GOAL =
  SECTION_2_SCORING.scoredPageIds.length * SECTION_2_SCORING.pointsPerQuestion

const Section2CompleteAnatomyV2 = (props: TPageProps) => {
  const answers = useSelector(selectAnswers)
  const pointsEarned = calculateSectionScore(SECTION_2_SCORING, answers)

  return (
    <SectionCompleteTemplate
      {...props}
      nextSectionNumber={NEXT_SECTION_NUMBER}
      titleI18nKey="onboarding.section2Complete.title"
      subtitleI18nKey="onboarding.section2Complete.subtitle"
      pointsEarned={pointsEarned}
      pointsGoal={POINTS_GOAL}
      question="Section 2 complete"
    />
  )
}

export default Section2CompleteAnatomyV2
